import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "m22.407 18.535 1.826 2.283a.521.521 0 1 1-.814.65l-1.68-2.099-1.68 2.1a.52.52 0 0 1-.882-.06.523.523 0 0 1 .068-.591l1.826-2.284-.537-.67a.522.522 0 1 1 .815-.653l.39.489 1.002-1.252h-3.61a.522.522 0 0 1 0-1.044h2.086v-.522a.522.522 0 0 1 1.044 0v.522h2.087a.522.522 0 0 1 0 1.044h-.271l-1.67 2.087ZM9.141 14.752 8.134 17.17a.522.522 0 1 1-.964-.401l2.609-6.261a.522.522 0 0 1 .963 0l2.609 6.244a.522.522 0 0 1-.963.403l-1.003-2.403H9.14Zm.435-1.044h1.372l-.686-1.644-.686 1.644Zm-4.533 4.827h5.74a.521.521 0 1 1 0 1.043H4.522A.52.52 0 0 1 4 19.056V8.621a.522.522 0 0 1 .522-.521h13.043a.522.522 0 1 1 0 1.043H5.043v9.392Zm21.913-5.218h-5.739a.522.522 0 0 1 0-1.043h6.261a.522.522 0 0 1 .522.521V23.23a.522.522 0 0 1-.522.522H14.435a.522.522 0 0 1 0-1.044h12.521v-9.39Zm-5.13-7.072a.522.522 0 1 1 .869.579L10.173 25.606a.522.522 0 0 1-.868-.578L21.827 6.245Z"
    }
  )
);
var SvgLanguageOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var LanguageOutlined_default = SvgLanguageOutlined;

export { LanguageOutlined_default as default };
